export const FETCH_SCHEDULING_CALENDAR_REQUEST = 'FETCH_SCHEDULING_CALENDAR_REQUEST';
export const FETCH_SCHEDULING_CALENDAR_SUCCESS = 'FETCH_SCHEDULING_CALENDAR_SUCCESS';
export const FETCH_SCHEDULING_CALENDAR_FAILURE = 'FETCH_SCHEDULING_CALENDAR_FAILURE';

export const FETCH_SCHEDULING_CALENDAR_METADATA_REQUEST = 'FETCH_SCHEDULING_CALENDAR_METADATA_REQUEST';
export const FETCH_SCHEDULING_CALENDAR_METADATA_SUCCESS = 'FETCH_SCHEDULING_CALENDAR_METADATA_SUCCESS';
export const FETCH_SCHEDULING_CALENDAR_METADATA_FAILURE = 'FETCH_SCHEDULING_CALENDAR_METADATA_FAILURE';

export const SET_SCHEDULING_CALENDAR_VIEW = 'SET_SCHEDULING_CALENDAR_VIEW';
export const SET_SCHEDULING_CALENDAR_SEARCH = 'SET_SCHEDULING_CALENDAR_SEARCH';
export const SET_SCHEDULING_CALENDAR_RANGE = 'SET_SCHEDULING_CALENDAR_RANGE';
export const SET_SCHEDULING_CALENDAR_LIST_STATE = 'SET_SCHEDULING_CALENDAR_LIST_STATE';

export const SAVE_SCHEDULING_CALENDAR_SHIFT_REQUEST = 'SAVE_SCHEDULING_CALENDAR_SHIFT_REQUEST';
export const SAVE_SCHEDULING_CALENDAR_SHIFT_SUCCESS = 'SAVE_SCHEDULING_CALENDAR_SHIFT_SUCCESS';
export const SAVE_SCHEDULING_CALENDAR_SHIFT_FAILURE = 'SAVE_SCHEDULING_CALENDAR_SHIFT_FAILURE';

export const DELETE_SCHEDULING_CALENDAR_SHIFT_REQUEST = 'DELETE_SCHEDULING_CALENDAR_SHIFT_REQUEST';
export const DELETE_SCHEDULING_CALENDAR_SHIFT_SUCCESS = 'DELETE_SCHEDULING_CALENDAR_SHIFT_SUCCESS';
export const DELETE_SCHEDULING_CALENDAR_SHIFT_FAILURE = 'DELETE_SCHEDULING_CALENDAR_SHIFT_FAILURE';

export const FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_REQUEST = 'FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_REQUEST';
export const FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_SUCCESS = 'FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_SUCCESS';
export const FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_FAILURE = 'FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_FAILURE';

export const CHECK_SCHEDULING_CALENDAR_ADHOC_REQUEST = 'CHECK_SCHEDULING_CALENDAR_ADHOC_REQUEST';
export const CHECK_SCHEDULING_CALENDAR_ADHOC_SUCCESS = 'CHECK_SCHEDULING_CALENDAR_ADHOC_SUCCESS';
export const CHECK_SCHEDULING_CALENDAR_ADHOC_FAILURE = 'CHECK_SCHEDULING_CALENDAR_ADHOC_FAILURE';

export const SAVE_SCHEDULING_CALENDAR_ADHOC_REQUEST = 'SAVE_SCHEDULING_CALENDAR_ADHOC_REQUEST';
export const SAVE_SCHEDULING_CALENDAR_ADHOC_SUCCESS = 'SAVE_SCHEDULING_CALENDAR_ADHOC_SUCCESS';
export const SAVE_SCHEDULING_CALENDAR_ADHOC_FAILURE = 'SAVE_SCHEDULING_CALENDAR_ADHOC_FAILURE';

export const GENERATE_SCHEDULING_CALENDAR_REQUEST = 'GENERATE_SCHEDULING_CALENDAR_REQUEST';
export const GENERATE_SCHEDULING_CALENDAR_SUCCESS = 'GENERATE_SCHEDULING_CALENDAR_SUCCESS';
export const GENERATE_SCHEDULING_CALENDAR_FAILURE = 'GENERATE_SCHEDULING_CALENDAR_FAILURE';

export const SET_SCHEDULING_CALENDAR_FILTERS = 'SET_SCHEDULING_CALENDAR_FILTERS';

export const CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_REQUEST = 'CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_REQUEST';
export const CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_SUCCESS = 'CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_SUCCESS';
export const CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_FAILURE = 'CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_FAILURE';

export const SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_REQUEST = 'SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_REQUEST';
export const SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_SUCCESS = 'SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_SUCCESS';
export const SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_FAILURE = 'SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_FAILURE';

export const FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_REQUEST = 'FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_REQUEST';
export const FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_SUCCESS = 'FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_SUCCESS';
export const FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_FAILURE = 'FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_FAILURE';

export const FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_REQUEST = 'FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_REQUEST';
export const FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_SUCCESS = 'FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_SUCCESS';
export const FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_FAILURE = 'FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_FAILURE';

export const DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_REQUEST = 'DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_REQUEST';
export const DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_SUCCESS = 'DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_SUCCESS';
export const DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_FAILURE = 'DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_FAILURE';

export const UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_REQUEST = 'UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_REQUEST';
export const UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_SUCCESS = 'UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_SUCCESS';
export const UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_FAILURE = 'UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_FAILURE';

export const CLEAR_SCHEDULING_CALENDAR_CREATED_SHARABLE_LINK = 'CLEAR_SCHEDULING_CALENDAR_CREATED_SHARABLE_LINK';

export const FETCH_TASK_FACILITIES_REQUEST = 'FETCH_TASK_FACILITIES_REQUEST';
export const FETCH_TASK_FACILITIES_SUCCESS = 'FETCH_TASK_FACILITIES_SUCCESS';
export const FETCH_TASK_FACILITIES_FAILURE = 'FETCH_TASK_FACILITIES_FAILURE';
export const CLEAR_TASK_FACILITIES = 'CLEAR_TASK_FACILITIES';